export const MIN_DESIRED_LOAN = 1000;
export const MAX_DESIRED_LOAN = 250000;
export const MIN_DESIRED_RATE = 150;
export const MAX_DESIRED_RATE = 2500;

export const MIN_TIME = '08:00';
export const MID_DAY_TIME = '12:00';
export const MAX_TIME = '20:00';
export const MIN_TIME_NUMBER = 8;
export const MAX_TIME_NUMBER = 20;
export const MIN_DEFAULT_TIME_NUMBER = 8;
export const MAX_DEFAULT_TIME_NUMBER = 12;

export const PHONE_NUMBER_LENGTH = 12;

export const CREDIT_MONTHLY_INSTALMENT_TIMEOUT = 'CREDIT_MONTHLY_INSTALMENT_TIMEOUT';
export const CREDIT_AMOUNT_INITIAL = 25000;
export const CREDIT_AMOUNT_MIN = 5000;
export const CREDIT_AMOUNT_MAX = 250000;
export const CREDIT_AMOUNT_STEP = 1000;
export const CREDIT_CONSTANT_C_HIGHER = 0.1095;
export const CREDIT_CONSTANT_C_LOWER = 0.069;
export const CREDIT_PAYMENT_INITIAL = 60;
export const CREDIT_PAYMENT_MIN = 12;
export const CREDIT_PAYMENT_MAX = 84;
export const CREDIT_PAYMENT_STEP = 6;
export const CREDIT_EXISTING_MONTHLY_INSTALLMENT_MIN = 0;
export const CREDIT_EXISTING_MONTHLY_INSTALLMENT_MAX = 2500;

export const SUPPORTED_ERRORS_CODES = [404, 500, 503];

// Storage
export const STORAGE_ACCESS_TOKEN = 'ACCESS_TOKEN';
export const STORAGE_VALID_TO = 'VALID_TO';
export const STORAGE_USER_DOCUMENTATION_LANGUAGE = 'USER_DOCUMENTATION_LANGUAGE';

// Phone number
export const PHONE_NUMBER_CODE_SWITZERLAND = '+41';
export const PHONE_NUMBER_CODES = [PHONE_NUMBER_CODE_SWITZERLAND];

export const PHONE_NUMBER_DATA: any = {
  [PHONE_NUMBER_CODE_SWITZERLAND]: {
    length: [12],
  },
}

export const NUMBER_OF_TESTIMONIALS = 6;

export const NUMBER_OF_BENEFITS = 4;
export const NUMBER_OF_STATS = 3;
export const NUMBER_OF_STEPS = 3;
export const NUMBER_OF_QUESTIONS = 17;
export const NUMBER_OF_PARTNERS = 3;
export const NUMBER_OF_SERVICES = 4;
export const NUMBER_OF_CARD_BENEFITS = 5;
export const NUMBER_OF_MOBILE_APP_BENEFITS = 8

export const NARROW_BACKGROUND_IMAGE = '/assets/family-2.png';

export const CREDIT_REQUEST_STEPS = 4;
export const CREDIT_REQUEST_FORM_STEPS = 4;
export const CREDIT_REQUEST_STEP_BASIC = 0;
export const CREDIT_REQUEST_STEP_FORM = 1;
export const CREDIT_REQUEST_STEP_DOCUMENTS = 2;
export const CREDIT_REQUEST_STEP_OVERVIEW = 3;

export const CREDIT_CARD_REQUEST_FORM_STEPS = 4;
export const CREDIT_CARD_REQUEST_STEP_PERSONAL = 0;
export const CREDIT_CARD_REQUEST_STEP_FAMILY = 1;
export const CREDIT_CARD_REQUEST_STEP_WORK = 2;
export const CREDIT_CARD_REQUEST_STEP_CARD = 3;

export const CREDIT_REQUEST_FORM_PADDING = '40px 50px';

export const EMAIL_ICON = '/assets/envelope.svg';
export const PHONE_ICON = '/assets/phone.svg';
export const LOCATION_ICON = '/assets/location.svg';

export const FACEBOOK_ICON = '/assets/facebook.svg';
export const LINKEDIN_ICON = '/assets/linkedin.svg';
export const INSTAGRAM_ICON = '/assets/instagram.svg';

export const LOGO_IMG = '/assets/logo-full.svg';
export const LOGO_DARK = '/assets/logo-dark.svg';

export const CARD_IMG = '/assets/card.svg';

export const FAMILY_IMG = '/assets/family.jpg';
export const TOWN_IMG = '/assets/town.jpg';
export const SUPPORT_IMG = '/assets/support.jpg';
export const TABLE_IMG = '/assets/table.jpg';

export const LOCK_PNG = '/assets/lock.png';

export const CHECK_ICON = '/assets/check.svg';
export const CHECK_FILLED_ICON = '/assets/check-filled.svg';

export const SWITZERLAND_IMG = '/assets/switzerland.svg';

export const DE_FLAG = '/assets/flags/de.svg';
export const EN_FLAG = '/assets/flags/en.svg';
export const FR_FLAG = '/assets/flags/fr.svg';
export const IT_FLAG = '/assets/flags/it.svg';
export const SR_FLAG = '/assets/flags/rs.svg';

export const ARROW_RIGHT_ICON = '/assets/arrow-right.svg';
export const ARROW_LEFT_ICON = '/assets/arrow-left.svg';

export const STARS_ICON = '/assets/stars.svg';

export const FAQ_IMGS = [
  { src: '/assets/question-1.png' },
  { src: '/assets/question-2.png' },
  { src: '/assets/question-3.png' }
];

export const GOOGLE_PLAY_IMG = '/assets/google-play.svg';
export const APP_STORE_IMG = '/assets/app-store.svg';
export const MOBILE_APP_IMG_SR = '/assets/mobile-app-sr.svg';
export const MOBILE_APP_IMG_EN = '/assets/mobile-app-en.svg';
export const MOBILE_APP_IMG_DE = '/assets/mobile-app-de.svg';

export const WEBKREDIT_SENDER_NAME = 'webkredit';
export const WEBKREDIT_SENDER_EMAIL = 'info@webkredit.ch';
export const WEBKREDIT_RECEIVER_NAME = 'Antrag';
export const WEBKREDIT_RECEIVER_EMAIL = 'antrag@webkredit.ch';
export const WEBKREDIT_EMAIL_TITLE = 'Webkredit.ch - Contact form - ';

// Mask input
export const MASK_SWISS_PHONE_NUMBER = '+41 __ ___ __ __';